import _extends from "@babel/runtime/helpers/extends";
import React, { useMemo } from 'react';
import { ExpanderContent } from "../../expander";
import { View } from "../../layout";
import { TdElement as Td, ThElement as Th } from "../html";
import { CellType } from "../interfaces";
import { getVerticalSpacingForCell } from "./utils";
import { jsx as ___EmotionJSX } from "@emotion/core";
export var ExpandableColumn = function ExpandableColumn(_ref) {
  var actionColumnIndex = _ref.actionColumnIndex,
      ariaLabel = _ref.ariaLabel,
      colIndex = _ref.colIndex,
      columns = _ref.columns,
      expandableRowHasTopBorder = _ref.expandableRowHasTopBorder,
      expandableRowIndex = _ref.expandableRowIndex,
      isActionCustomPosition = _ref.isActionCustomPosition,
      isExpanded = _ref.isExpanded,
      isSorted = _ref.isSorted,
      isStriped = _ref.isStriped,
      spacing = _ref.spacing,
      data = _ref.data,
      columnProps = _ref.columnProps;
  var _columnProps$dataCell = columnProps.dataCellType,
      dataCellType = _columnProps$dataCell === void 0 ? CellType.Data : _columnProps$dataCell,
      getCellExpandableContent = columnProps.expandableContent,
      textAlign = columnProps.textAlign,
      width = columnProps.width;
  var isCellTypeHeader = dataCellType === CellType.Header;
  var Cell = isCellTypeHeader ? Th : Td;
  var dataTypeCellProps = isCellTypeHeader ? {
    scope: 'row'
  } : {}; // expandableRowIndex might be out of bounds but that is ok as it's handled like an empty cell

  var ExpandableCellContent = useMemo(function () {
    return !!getCellExpandableContent && getCellExpandableContent({
      data: data,
      index: colIndex
    })[expandableRowIndex];
  }, [expandableRowIndex, getCellExpandableContent, data, colIndex]);
  return !!ExpandableCellContent ? ___EmotionJSX(React.Fragment, null, // Add an empty cell if actionColumnIndex is set and is matches the index of the current column
  isActionCustomPosition && actionColumnIndex === colIndex && ___EmotionJSX(Td, null), ___EmotionJSX(Cell, _extends({
    isStriped: isStriped,
    textAlign: textAlign,
    width: width,
    "aria-label": ariaLabel,
    verticalAlign: "top"
  }, dataTypeCellProps), ___EmotionJSX(ExpanderContent, {
    isExpanded: isExpanded,
    shouldAnimateImmediately: isSorted,
    topSpacing: expandableRowHasTopBorder ? getVerticalSpacingForCell(spacing) : undefined
  }, ___EmotionJSX(View, {
    padding: {
      bottom: getVerticalSpacingForCell(spacing)
    }
  }, ExpandableCellContent))), // Add an empty action cell if actionColumnIndex points to the last column
  !!actionColumnIndex && colIndex === columns.length - 1 && actionColumnIndex - 1 >= colIndex && ___EmotionJSX(Td, null)) : ___EmotionJSX(Cell, {
    key: colIndex
  });
};